import { __awaiter, __generator } from "tslib";
import '../polyfill';
import { reportHomePageLoadedDuration, reportHomePagePaintDuration } from '../../logger/homePageLoad';
import { appDataInitialize, bootstrap } from './bootstrap';
import { fetchHandleError } from '../FetchConfig';
import { handleError } from './util';
window.addEventListener('load', function () {
    reportHomePageLoadedDuration();
    reportHomePagePaintDuration();
});
fetchHandleError(handleError);
appDataInitialize();
window.addEventListener('DOMContentLoaded', function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        bootstrap();
        return [2];
    });
}); });
